import styled from "styled-components";
import { motion } from "framer-motion";

export const ContainerNecesitoTurno = styled(motion.div)`
  width: 100%;
  height: 100vh;
`;

export const TextNecesitoTurno = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 20%;
  margin-top: 30px;
  .title-saludo {
    color: #1a1a1a;
    text-align: center;
    font-family: Rubik;
    font-size: 16px;
    font-style: normal;
    line-height: 150%;
    width: 320px;
  }
  .title-pregunta {
    font-weight: 400;
    font-size: 22px;
    line-height: 150%;
    text-align: center;
    width: 365px;
  }
  .title-negrita {
    font-weight: bold;
  }
`;

export const BtnContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 26px;
  svg {
    width: 25px;
    height: 25px;
  }
`;
